import React from 'react';
import Carousel from 'nuka-carousel';
import Slider from './Slider';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import './styles.css'

const SliderContainer = () => {

  const items = [
    {
      img: "../images/slider/slider06.jpg",
      title: "Discover",
      subTitle: "Apparel Curated for You",
      desc: "Explore a collection crafted to your unique size, fit, and style. Every listing is tailored so that what you discover is destined to fit you—literally.",
    },
    {
      img: "../images/slider/slider03.jpg",
      title: "Marketplace",
      subTitle: "Social Community",
      desc: "Join a dynamic peer-to-peer marketplace where you can list and sell your apparel with ease. Enjoy genuine offers and stress-free transactions without lowball pressures.",
    },
    {
      img: "../images/slider/slider04.jpg",
      title: "Bargains",
      subTitle: "Sustainable Fashion Finds",
      desc: "Refresh your wardrobe sustainably—our members uncover eco-friendly bargains that allow frequent style updates without overspending.",
    },
    {
      img: "../images/slider/slider05.jpg",
      title: "DressTwin",
      subTitle: "Exclusive Community",
      desc: "Step into an invitation-only world designed for true fashion enthusiasts. Our closed community ensures genuine connections and personalized fit at every turn.",
    },
    {
      img: "../images/slider/slider02.jpg",
      title: "Referral",
      subTitle: "Get Your Invitation",
      desc: "Think you belong? Complete our referral request form and secure your exclusive invitation to join the revolution in perfectly fit fashion.",
    },
    {
      img: "../images/slider/slider08.jpg",
      title: "Deals",
      subTitle: "Clothing Deals",
      desc: "Unlock unparalleled deals on premium pre-loved fashion. Our community brings you top-condition items at prices you won’t find anywhere else.",
    },
  ];


  let deviceDetect = 1;
  if (window.innerWidth <= 800) {
    deviceDetect = 1;
  } else if (window.innerWidth <= 1400) {
    deviceDetect = 2;
  } else if (window.innerWidth <= 5000) {
    deviceDetect = 3;
  } else {
    deviceDetect = 3
  }

  return (
    <section className='slider-section'>
      <Carousel
        renderCenterLeftControls={({ previousSlide }) => (
          <button onClick={previousSlide}>
            <ArrowBackIosIcon />
          </button>
        )}
        renderCenterRightControls={({ nextSlide }) => (
          <button onClick={nextSlide}>
            <ArrowForwardIosIcon />
          </button>
        )}
        slidesToShow={deviceDetect}
        wrapAround={true}
        cellSpacing={40}
      >
        {
          items.map((item: any, itemIndex: number) => {
            return (
              <Slider imgLink={item.img} title={item.title} subTitle={item.subTitle} desc={item.desc} key={itemIndex} />
            )
          })
        }
      </Carousel>
    </section>
  );
}

export default SliderContainer